const JOURNEY_ID_KEY = 'onboarding_current_journey_id';
const JOURNEY_LABEL_KEY = 'onboarding_current_journey_label';
const ALL_JOURNEYS_ID = 'all-journeys';
const ALL_JOURNEYS_LABEL = 'All Journeys';

function can_use_session_storage() {
  return typeof sessionStorage !== 'undefined';
}

function normalize_text(value) {
  return String(value || '').trim();
}

function get_route_journey_id(route = {}) {
  return normalize_text(route.params?.journeyId || route.query?.journey || '');
}

function get_route_journey_label(route = {}) {
  return normalize_text(route.query?.journey_label || route.query?.label || '');
}

function get_journey_id(journey = {}) {
  return normalize_text(journey.id || journey.journey || '');
}

function get_journey_label(journey = {}) {
  return normalize_text(journey.label || journey.journey_label || '');
}

function get_stored_value(key = '') {
  if (!can_use_session_storage()) return '';
  return normalize_text(sessionStorage.getItem(key));
}

function set_stored_value(key = '', value = '') {
  if (!can_use_session_storage()) return;
  sessionStorage.setItem(key, normalize_text(value));
}

function should_clear_journey_filter(journey_id = '', journey_label = '') {
  const is_empty_journey = !journey_id;
  const is_all_journeys = journey_id === ALL_JOURNEYS_ID;
  const is_all_label = journey_label === ALL_JOURNEYS_LABEL;
  return is_empty_journey || is_all_journeys || is_all_label;
}

function has_route_journey_filter(route_journey_id = '', route_journey_label = '') {
  return Boolean(route_journey_id || route_journey_label);
}

function build_route_journey_filter(route_journey_id = '', route_journey_label = '') {
  const route_filter = {
    id: route_journey_id,
    label: route_journey_label || ALL_JOURNEYS_LABEL
  };
  return route_filter;
}

function build_stored_journey_filter() {
  const stored_journey_id = get_stored_value(JOURNEY_ID_KEY);
  const stored_journey_label = get_stored_value(JOURNEY_LABEL_KEY);
  const stored_filter = {
    id: stored_journey_id,
    label: stored_journey_label || ALL_JOURNEYS_LABEL
  };
  return stored_filter;
}

export function clear_onboarding_journey_filter() {
  set_stored_value(JOURNEY_ID_KEY, '');
  set_stored_value(JOURNEY_LABEL_KEY, ALL_JOURNEYS_LABEL);
}

export function persist_onboarding_journey_filter(journey = {}) {
  const journey_id = get_journey_id(journey);
  const journey_label = get_journey_label(journey);
  if (should_clear_journey_filter(journey_id, journey_label)) {
    clear_onboarding_journey_filter();
    return;
  }

  set_stored_value(JOURNEY_ID_KEY, journey_id);
  set_stored_value(JOURNEY_LABEL_KEY, journey_label);
}

export function sync_onboarding_journey_filter_from_route(route = {}) {
  const journey_id = get_route_journey_id(route);
  const journey_label = get_route_journey_label(route);
  if (has_route_journey_filter(journey_id, journey_label)) {
    persist_onboarding_journey_filter({ id: journey_id || ALL_JOURNEYS_ID, label: journey_label });
  }
}

export function resolve_onboarding_journey_filter(route = {}) {
  const route_journey_id = get_route_journey_id(route);
  const route_journey_label = get_route_journey_label(route);
  if (has_route_journey_filter(route_journey_id, route_journey_label)) {
    return build_route_journey_filter(route_journey_id, route_journey_label);
  }

  return build_stored_journey_filter();
}

export function resolve_onboarding_journey_filter_key(route = {}) {
  return String(resolve_onboarding_journey_filter(route).id || '').trim().toLowerCase();
}

export function build_onboarding_journey_query(route = {}) {
  const journey_filter = resolve_onboarding_journey_filter(route);
  if (!journey_filter.id) {
    return {};
  }

  const query = {
    journey: journey_filter.id
  };
  if (journey_filter.label) query.journey_label = journey_filter.label;
  return query;
}
